/**
 * BaB footer spend progress bar
 * Injects a $140 minimum-spend bar above the Awtomic bundle footer row.
 * Fill starts at 0%; message becomes "All Set!" when the goal is met.
 * Subscribe / Add to cart stays disabled until the goal is met.
 */
(function () {
  var GOAL = 140;
  var BAR_ATTR = 'data-custom-bab-spend-bar';
  var FOOTER_SELECTOR = '.bundle-container footer';
  var PRICE_SELECTOR = '.bundle-text--emphasis';
  var SUBSCRIBE_SELECTOR = 'button.bundle-button.button--primary';
  var LOCKED_CLASS = 'custom-bab-subscribe--locked';
  var MESSAGE_INCOMPLETE = 'Spend at least $140';
  var MESSAGE_COMPLETE = 'All Set!';

  var updating = false;
  var scheduled = false;

  function parseMoney(text) {
    if (!text) return 0;
    var cleaned = String(text).replace(/[^0-9.]/g, '');
    var value = parseFloat(cleaned);
    return isNaN(value) ? 0 : value;
  }

  function getSpend(footer) {
    var priceEl = footer.querySelector(PRICE_SELECTOR);
    // Prefer the cart total in the footer actions, not any text inside our bar
    if (!priceEl || priceEl.closest('[' + BAR_ATTR + ']')) {
      var candidates = footer.querySelectorAll(PRICE_SELECTOR);
      priceEl = null;
      for (var i = 0; i < candidates.length; i++) {
        if (!candidates[i].closest('[' + BAR_ATTR + ']')) {
          priceEl = candidates[i];
          break;
        }
      }
    }
    return priceEl ? parseMoney(priceEl.textContent) : 0;
  }

  function ensureBar(footer) {
    var existing = footer.querySelector('[' + BAR_ATTR + ']');
    if (existing) {
      // Upgrade older markup (message nested inside fill) if needed
      if (!existing.querySelector('.custom-bab-spend-bar__track > .custom-bab-spend-bar__message')) {
        existing.innerHTML =
          '<div class="custom-bab-spend-bar__track">' +
          '<div class="custom-bab-spend-bar__fill" style="width: 0%"></div>' +
          '<span class="custom-bab-spend-bar__message">' +
          MESSAGE_INCOMPLETE +
          '</span>' +
          '</div>';
      }
      return existing;
    }

    var bar = document.createElement('div');
    bar.className = 'custom-bab-spend-bar';
    bar.setAttribute(BAR_ATTR, '');
    bar.innerHTML =
      '<div class="custom-bab-spend-bar__track">' +
      '<div class="custom-bab-spend-bar__fill" style="width: 0%"></div>' +
      '<span class="custom-bab-spend-bar__message">' +
      MESSAGE_INCOMPLETE +
      '</span>' +
      '</div>';

    var inner = footer.firstElementChild;
    if (inner) {
      inner.insertBefore(bar, inner.firstChild);
    } else {
      footer.insertBefore(bar, footer.firstChild);
    }

    return bar;
  }

  function getSubscribeButton(footer) {
    var buttons = footer.querySelectorAll(SUBSCRIBE_SELECTOR);
    for (var i = 0; i < buttons.length; i++) {
      if (!buttons[i].closest('[' + BAR_ATTR + ']')) {
        return buttons[i];
      }
    }
    return null;
  }

  function updateSubscribeButton(footer, met) {
    var button = getSubscribeButton(footer);
    if (!button) return;

    if (met) {
      if (button.hasAttribute('disabled')) button.removeAttribute('disabled');
      if (button.getAttribute('aria-disabled') !== 'false') {
        button.setAttribute('aria-disabled', 'false');
      }
      if (button.classList.contains(LOCKED_CLASS)) {
        button.classList.remove(LOCKED_CLASS);
      }
    } else {
      if (!button.hasAttribute('disabled')) button.setAttribute('disabled', '');
      if (button.getAttribute('aria-disabled') !== 'true') {
        button.setAttribute('aria-disabled', 'true');
      }
      if (!button.classList.contains(LOCKED_CLASS)) {
        button.classList.add(LOCKED_CLASS);
      }
    }
  }

  function updateBar(footer) {
    var bar = ensureBar(footer);
    var fill = bar.querySelector('.custom-bab-spend-bar__fill');
    var message = bar.querySelector('.custom-bab-spend-bar__message');
    if (!fill || !message) return;

    var spend = getSpend(footer);
    var met = spend >= GOAL;
    var percent = met ? 100 : Math.min(100, Math.max(0, (spend / GOAL) * 100));
    var nextWidth = percent + '%';
    var nextMessage = met ? MESSAGE_COMPLETE : MESSAGE_INCOMPLETE;

    if (fill.style.width !== nextWidth) {
      fill.style.width = nextWidth;
    }

    if (bar.classList.contains('is-complete') !== met) {
      bar.classList.toggle('is-complete', met);
    }

    if (message.textContent !== nextMessage) {
      message.textContent = nextMessage;
    }

    if (message.hidden) {
      message.hidden = false;
    }

    updateSubscribeButton(footer, met);
  }

  function syncAll() {
    if (updating) return;
    updating = true;
    try {
      document.querySelectorAll(FOOTER_SELECTOR).forEach(updateBar);
    } finally {
      updating = false;
    }
  }

  function scheduleSync() {
    if (scheduled || updating) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      syncAll();
    });
  }

  function observe() {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var target = mutations[i].target;
        if (!target) continue;
        // Ignore mutations caused by our own progress bar
        if (
          (target.nodeType === 1 && target.closest && target.closest('[' + BAR_ATTR + ']')) ||
          (target.parentElement && target.parentElement.closest('[' + BAR_ATTR + ']'))
        ) {
          continue;
        }
        scheduleSync();
        return;
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
    });
  }

  // Block clicks while under the minimum even if Awtomic re-enables the button
  function bindClickGuard() {
    document.addEventListener(
      'click',
      function (e) {
        var button =
          e.target && e.target.closest && e.target.closest(FOOTER_SELECTOR + ' ' + SUBSCRIBE_SELECTOR);
        if (!button || !button.classList.contains(LOCKED_CLASS)) return;
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );
  }

  function init() {
    syncAll();
    observe();
    bindClickGuard();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
